import React from "react";
import { GmbHDetails } from "lib/models/client/GmbHDetails";
import { Container } from "react-bootstrap";
import { getWepaBookings_getWepaBookings_bookings } from "lib/api/queries/graphql/getWepaBookings";
import { StorageConfigStructure } from "components/client/company/components/GetStorageConfig";
import { AdminServiceStatusEnum } from "lib/models/client/GmbH";
import { FeatureFlagService } from "lib/services/FeatureFlagService/FeatureFlagService";
import { FeatureFlags } from "global-query-types";
import { WepaGeneralData } from "client/components/WepaSection/WepaGeneralData/WepaGeneralData";
import WepaIsBeingPrepared from "client/components/WepaSection/WepaIsBeingPrepared/WepaIsBeingPrepared";
import WepaUpsell from "client/components/WepaSection/WepaUpsell/WepaUpsell";
import { GetFormerClientAssignments_getFormerClientAssignments_items } from "../../../lib/api/queries/graphql/GetFormerClientAssignments";

interface WepaSectionProps {
  gmbh: GmbHDetails;
  bookings: getWepaBookings_getWepaBookings_bookings[];
  onConfirmBooking: (bookingId: number) => void;
  wepaStructure: StorageConfigStructure[];
  formerClientAssignments: GetFormerClientAssignments_getFormerClientAssignments_items[];
}

const WepaSection = ({
  gmbh,
  bookings,
  onConfirmBooking,
  wepaStructure,
  formerClientAssignments
}: WepaSectionProps) => {
  const showWepaTabContentBasedOnStatus = FeatureFlagService.instance.isEnabled(
    FeatureFlags.AlwaysShowWepaTabInCompanyPage
  );

  const adminServiceStatus = gmbh.adminServiceStatus;

  const hasPendingAdminService: boolean =
    adminServiceStatus === AdminServiceStatusEnum.ORDER_PENDING ||
    adminServiceStatus === AdminServiceStatusEnum.WAITING_FOR_CONFIRMATION;

  const hasActiveAdminService: boolean = gmbh.adminServiceStatus === AdminServiceStatusEnum.ACTIVE;

  const showWepaUpsell =
    showWepaTabContentBasedOnStatus &&
    !gmbh.isWepaClient &&
    !hasActiveAdminService &&
    !hasPendingAdminService;

  const showWepaIsBeingPrepared =
    showWepaTabContentBasedOnStatus && !gmbh.isWepaClient && hasPendingAdminService;

  const hasFormerClientAssignments = formerClientAssignments.length > 0;

  const showGeneralData =
    !showWepaTabContentBasedOnStatus ||
    hasActiveAdminService ||
    gmbh.isWepaClient ||
    hasFormerClientAssignments;

  return (
    <Container data-testid="wepa-section" className="mb-5">
      {showWepaUpsell && <WepaUpsell />}
      {showWepaIsBeingPrepared && <WepaIsBeingPrepared />}
      {showGeneralData && (
        <WepaGeneralData
          gmbh={gmbh}
          bookings={bookings}
          onConfirmBooking={onConfirmBooking}
          wepaStructure={wepaStructure}
        />
      )}
    </Container>
  );
};

export default WepaSection;
